module.exports = __webpack_public_path__ + "img/icon2.acc2a160.svg";